import { defineStore } from "pinia";
import { ref } from "vue";
import { defaultSprite } from "@/assets/defaultSprite";

export const useUserInfoStore = defineStore("userInfo", () => {
  const displayName = ref<string>("Anonymous");
  const uid = ref<string>("");
  const rating = ref<number>(1000);
  const profilePic = ref<string>(defaultSprite);
  const loggedIn = ref<boolean>(false);

  const setDisplayName = (newName: string) => {
    displayName.value = newName;
  };

  const setProfilePic = (newProfilePic: string) => {
    profilePic.value = newProfilePic;
  };

  const setRating = (newRating: number) => {
    rating.value = newRating;
  };

  const logIn = (id: string) => {
    uid.value = id;
    loggedIn.value = true;
    console.log(`User logged in!`);
  };

  const logOut = () => {
    loggedIn.value = false;
    uid.value = "";
    profilePic.value = defaultSprite;
    displayName.value = "Anonymous";
    console.log("User logged out.");
  };

  return {
    loggedIn,
    uid,
    displayName,
    profilePic,
    rating,
    logIn,
    logOut,
    setDisplayName,
    setProfilePic,
    setRating,
  };
});
